zfrespond.views.CompletedModalView = Backbone.View.extend({
  
  events: {
    'click .action-close': 'onClose',
    'keydown': 'preventNavigation'
  },

  template: ZFRESPOND_JST['respond.completed_modal'],

  className: 'completed-modal-view',
  
  render: function() {
    this.$el.html(this.template({
      publicLinkUrl: this.model.getRespondPageUrl(),
      showShareLink: !this.model.get('should_hide_share_link')
    }));

    this.$('input[type=text]').on('focus', function() {
      $(this).select();
    });

  },
  
  preventNavigation: function(e) {
    var BACKSPACE = 8;
    if (e.keyCode == BACKSPACE) {
      e.preventDefault();
    }
  },

  focusOnInput: function() {
    if (!this.model.get('should_hide_share_link')) {
      this.$('input[type=text]').focus();
    }
  },
  
  onClose: function(){
    this.remove();
  }

}, {
  show : function(exposedMediaCollector) {
    var completedModal = new zfrespond.views.CompletedModalView({
      model: exposedMediaCollector
    });
    completedModal.render();
    $('body').append(completedModal.$el);
    completedModal.focusOnInput();
    return completedModal;
  }
});